import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import LoginPageForm from './LoginPageForm';
import { setUserAuthenticated } from '../../redux/userIsAuthenticatedReducer';
import { loginUser } from '../../api/loginApi';
import { tokenKey, refreshTokenKey, expirationKey } from "../../api/OAuth";
import { appTitle } from "../common/GeneralConfigurations";
import { AppRoutes } from '../../AppRoutes';
import { saveUserProfileFromToken } from '../../utils/userProfileUtils';

function ManageLoginPage() {
  const navigate = useNavigate();
  const [errors, setErrors] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = `${appTitle} - Login`;
  }, []);

  const [submitLoading, setSubmitLoading] = useState(false)

  const handleLogin = async (event) => {
    if (event && event.email && event.password) {
      setSubmitLoading(true)
      await loginUser({ email: event.email, password: event.password })
        .then((response) => {
          if (response.status === 200) {
            localStorage.setItem(tokenKey, response.data.token);
            localStorage.setItem(refreshTokenKey, response.data.refreshToken);
            localStorage.setItem(expirationKey, response.data.expiration);
            saveUserProfileFromToken(response.data.token);
            dispatch(setUserAuthenticated());
            navigate(AppRoutes.home.path);
          }
        })
        .catch((errors) => {
            setSubmitLoading(false);
            if (errors.response) {
                setErrors(errors.response.data[0].message);
            } else {
                setErrors("An error has occurred. Try again later.");
            }
        });
    }
  }

  return <div>
    <LoginPageForm handleLogin={handleLogin} errors={errors} submitLoading={submitLoading}/>
  </div>;
}

export default ManageLoginPage;
